import Drag from './drag'
import { file } from "@/api/files";
import { Message } from 'element-ui';

export default class ImgDrag extends Drag {
  useType = 'make';
  rightKeyMenu = null;
  blockInfo = {
    uuid: '',
    x: 80,
    y: 80,
    width: 80,
    height: 80,
    rightBottomCoordinate: {
      x: 160,
      y: 160
    },
    image: '',
    opaqueBottom: true, // 不透明底： true， 透明底： false
    mislead: true, // 誤導标记 false: 誤導， true: 正确答案
  };

  /**
   * 
   *   @param {String} plate: 区域類名(.question-design) || body
   *   @param {String} useType: 使用類型。 value: ['make', 'view']. 默认 ‘make’
   *   @param {Object} blockStyle 
   *    style: 方块样式,
   *    selectStyle: 方块选中样式
   *   @param {number | string} maxNum: 允许最多方块 默认10
   */
  constructor(obj) {
    super(obj)

    this.useType = obj.useType || this.useType
    
    this.init()
  }

  init() {
    this.customRightKeyMenu()
    
    // 只有make 才能调用
    this.useType == 'make' && this.findscroller()
  }

  // 调用基類 创建方块
  handleCreateBlock(mislead = true, info = null) {
    info = JSON.parse(JSON.stringify(info || this.blockInfo))
    info.mislead = mislead
    this.createBlock(node => {
      this.rightKeyEvent(node)
    }, '', '', info)
  }

  /**
   * 绑定右键事件
   * @param {*} node 
   *    绑定事件的节点
   */
  rightKeyEvent(node) {
    node.addEventListener('contextmenu', ev => {
      ev.preventDefault()

      let { rightKeyMenu, curBlock } = this
      rightKeyMenu.style.display = 'block'
      rightKeyMenu.style.left = `${ev.pageX}px`
      rightKeyMenu.style.top = `${ev.pageY}px`
      rightKeyMenu.focus()
      
      for(let i = 0; i < rightKeyMenu.childNodes.length; i++) {
        let item = rightKeyMenu.childNodes[i]

        if([...item.classList].indexOf('mislead-choice') > -1) {
          item.innerText = curBlock.mislead ? '設為誤導選項' : '取消誤導選項'
        }
        if([...item.classList].indexOf('opaque-bottom') > -1) {
          item.innerText = curBlock.opaqueBottom ? '設置為透明底層' : '設置為不透明底層' 
          break ;
        }
      }
    })
  }

  /**
   * 右键自定义菜单
   */
  customRightKeyMenu() {
    let menu = document.createElement('div')
    menu.setAttribute('class', 'right-key-menu')
    menu.setAttribute('tabindex', '0')
    let singleMenu = [
      {text: '複製', class: 'copy'},
      {text: '上傳圖片', class: 'update-image'},
      // {text: '誤導选项', class: 'mislead-choice'},
      {text: '設置為透明底層', class: 'opaque-bottom'},
      {text: '刪除', class: 'remove-block'}
    ]

    // 追加子节点
    while(menu.childNodes.length < singleMenu.length) {
      let child = document.createElement('div'),
      item = singleMenu[menu.childNodes.length]
      child.setAttribute('class', `menu-single ${item.class}`)
      child.innerText = item.text

      // 每个按钮增加事件
      if(menu.childNodes.length == 0) child.addEventListener('click', copyBlock)
      if(menu.childNodes.length == 1) child.addEventListener('click', updateImg)
      // if(menu.childNodes.length == 2) child.addEventListener('click', misleadChoice)
      if(menu.childNodes.length == 2) child.addEventListener('click', setOpaqueBottom)
      else if(menu.childNodes.length == 3) child.addEventListener('click', removeBlock)

      menu.append(child)
    }

    menu.style.display = 'none'
    document.body.append(menu)
    this.rightKeyMenu = menu

    // 添加失去焦点事件
    menu.addEventListener('blur', () => {
      menu.style.display = 'none'
    })

    //  -------- 子节点事件函數 --------
    let that = this

    // 复制块元素
    function copyBlock() {
      let { curBlock } = that,
      // 偏移量
      offset = 40,
      copyBlockInfo = JSON.parse(JSON.stringify(curBlock))
      copyBlockInfo.x += offset
      copyBlockInfo.y += offset
      copyBlockInfo.rightBottomCoordinate.x += offset
      copyBlockInfo.rightBottomCoordinate.y += offset

      that.rightKeyMenu.blur()
      that.handleCreateBlock(curBlock.mislead, copyBlockInfo)
    }

    // 上傳圖片
    function updateImg() {
      let nodes = document.querySelector(`#${that.curBlock.uuid}`)
      console.log(nodes)
      
      let fileDom = document.createElement('input')
      fileDom.type = 'file'
      fileDom.onchange = () => {
        let files = fileDom.files[0],
        formData = new FormData();
        formData.append('file', files);

        file('/files', formData)
          .then((v) => {
            Message({ type: "success", message: "上傳成功!"});
            // 临时圖片
            let node = document.querySelector(`#${that.curBlock.uuid}`)
            that.curBlock.image = v.data
            node.style.backgroundImage = `url(${that.curBlock.image})`
            node.classList.remove('error-block-style')
            
          }).finally(() => {
            // 重置
            fileDom.value = ''
            that.fn(that.blockMap)
          });
      }

      fileDom.click()
    }

    // 誤導选项
    // function misleadChoice () {
    //   let { curBlock } = that
    //   curBlock.mislead = !curBlock.mislead

    //   that.rightKeyMenu.blur()
    //   that.fn(that.blockMap)
    // }

    // 切换透明底层
    function setOpaqueBottom() {
      // 設置為透明底層
      let { curBlock: { uuid }, curBlock } = that,
      node = document.querySelector(`#${uuid}`),
      bgcolor = 'rgba(0, 0, 0, 0)'

      // 处理數据
      curBlock.opaqueBottom = !curBlock.opaqueBottom
      if(curBlock.opaqueBottom) bgcolor = '#ccc'

      // 样式修改
      node.style.backgroundColor = bgcolor
      that.rightKeyMenu.blur()

      that.fn(that.blockMap)
    }

    // 移除方块
    function removeBlock() {
      let { uuid } = that.curBlock,
      { plate } = that,
      removeNode = document.querySelector(`#${uuid}`)

      plate.removeChild(removeNode)
      that.blockMap.delete(uuid)
      that.curBlock = {}
      that.rightKeyMenu.blur()

      that.fn(that.blockMap)
    }
  }

  /**
   * 回显视图
   * @param {Array} map 
   */
  handleEchoBlock(map, vue) {
    // console.log(map)
    this.echoBlock(map, (node, curBlock) => {
      // 背景圖片
      node.style.backgroundImage = `url(${curBlock.image})`

      // 透明底
      if(curBlock.opaqueBottom) node.style.backgroundColor = '#ccc'
      else node.style.backgroundColor = 'rgba(0, 0, 0, 0)'

      // 添加拖动事件
      this.insertEvent(node, map, vue)

      this.rightKeyEvent(node)
    })
  }

  /**
   * 回显方块 添加事件
   * @param {node} node 
   */
  insertEvent(node, map, vue) {
    let { existImage } = vue
    node.ondragover = ev => {
      ev.stopPropagation()
      ev.preventDefault()
    }

    node.ondrop = ev => {
      let mark = ev.dataTransfer.getData('info')
      , subscript = node.dataset.subscript

      // 当前 block 是否存在mark标记
      if(node.dataset.mark != -1) {
        // 消除标记
        existImage.splice(existImage.indexOf(node.dataset.mark), 1)
      }

      // 标记
      node.dataset.mark = mark
      existImage.push(Number(mark))

      // 更新视图
      node.style.backgroundImage = `url(${map[mark].image})`
      if(map[subscript].image == map[mark].image) {
        node.querySelector('.success').style.display = 'block'
        node.querySelector('.error').style.display = 'none'
      } else {
        node.querySelector('.success').style.display = 'none'
        node.querySelector('.error').style.display = 'block'
      }
    }

    // 移除已有的圖片
    node.onclick = () => {
      let mark = Number(node.dataset.mark)
      
      if(mark != -1) {
        // 更新视图
        node.querySelector('.success').style.display = 'none'
        node.querySelector('.error').style.display = 'none'

        node.style.backgroundImage = `url()`
        node.dataset.mark = -1

        existImage.splice(existImage.indexOf(mark), 1)
      }
    }
  }
}